import { FormContext, FormGroup, FormLabel, RadioButtonGroup, RadioButton } from '@hai/ui-react';
import React from 'react';

interface RadioItem {
  label: string;
  value: string;
}

interface Props {
  className?: string;
  name?: string;
  label: string;
  labelClass?: string;
  mask?: boolean;
  radios: Array<RadioItem>;
  value?: string;
}

export const FormRadios: React.FunctionComponent<Props> = ({
  name,
  label,
  labelClass = '',
  mask,
  radios,
  value,
  ...rest
}) => {
  return (
    <FormContext.Consumer>
      {(formContext: any) => {
        if (name !== undefined && name !== '' && value === undefined) {
          const meta = formContext?.getFieldMeta(name);
          const formikValue = meta?.touched ? meta.value : meta?.initialValue;
          value = value !== undefined ? value : formikValue;
        }
        return (
          <FormGroup {...rest}>
            <FormLabel className={labelClass}>{label}</FormLabel>
            <RadioButtonGroup
              className="mk-radios-horizontal"
              checkedValue={value}
              groupName={name}
              {...{ useFsMask: mask }}
            >
              {radios.map((radio, index) => {
                return (
                  <RadioButton key={index} value={radio.value}>
                    {radio.label}
                  </RadioButton>
                );
              })}
            </RadioButtonGroup>
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
